import { atomWithStorage, createJSONStorage } from "jotai/utils";

const baseStorage =
  typeof window === "undefined"
    ? {
        getItem: () => null,
        setItem: () => undefined,
        removeItem: () => undefined,
      }
    : window.localStorage;

const storage = createJSONStorage<AppLanguage>(() => baseStorage);

export type AppLanguage = "es" | "en" | "pt-BR";

export const languageAtom = atomWithStorage<AppLanguage>(
  "backoffice.preferences.language",
  "es",
  storage
);
